<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          정기안전점검 결과표
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">

          <!-- 기본정보 -->
          <m-title label="기본정보" />
          <m-form class="mb-4" label="용역명" :value="form.body.baseInfo.용역명" >
            <vs-input class="w-full" v-model="form.body.baseInfo.용역명" />
          </m-form>
          <m-group :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.project_name"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.com_name"/>
            </m-form>
            <m-form label="점검시간" :value="`${form.body.baseInfo.check_stime} ~ ${form.body.baseInfo.check_etime}`" >
              <div class="grid" style="grid-template-columns: 1fr 40px 1fr;">
                <time-selector class="w-full" v-model="form.body.baseInfo.check_stime" />
                <span class="w-full flex" style="justify-content: center; align-items: center;">~</span>
                <time-selector class="w-full" v-model="form.body.baseInfo.check_etime" />
              </div>
            </m-form>

            <m-form label="관리주체" :value="form.body.baseInfo.관리주체" >
              <vs-input class="w-full" v-model="form.body.baseInfo.관리주체"/>
            </m-form>
            <m-form label="소유자" :value="form.body.baseInfo.소유자" >
              <vs-input class="w-full" v-model="form.body.baseInfo.소유자"/>
            </m-form>
            <m-form label="공동수급" :value="form.body.baseInfo.공동수급" >
              <vs-input class="w-full" v-model="form.body.baseInfo.공동수급"/>
            </m-form>

            <m-form label="계약방법" :value="form.body.baseInfo.계약방법" >
              <vs-input class="w-full" v-model="form.body.baseInfo.계약방법"/>
            </m-form>
            <m-form label="시설물구분" :value="form.body.baseInfo.시설물구분" >
              <vs-input class="w-full" v-model="form.body.baseInfo.시설물구분"/>
            </m-form>
            <m-form label="구분" :value="form.body.baseInfo.구분" >
              <vs-input class="w-full" v-model="form.body.baseInfo.구분"/>
            </m-form>

            <m-form label="종별" :value="form.body.baseInfo.종별" >
              <vs-input class="w-full" v-model="form.body.baseInfo.종별"/>
            </m-form>
            <m-form label="사용 승인일" :value="form.body.baseInfo.사용승인일" >
              <date-selector class="w-full" v-model="form.body.baseInfo.사용승인일"/>
            </m-form>
            <m-form label="금액(천원, VAT포함)" :value="form.body.baseInfo.금액" >
              <div style="position: relative">
                <div class="text-padding-right">
                  <vs-input class="w-full" v-model="form.body.baseInfo.금액"/>
                </div>
                <div style="position: absolute; top: 0; right: 0.5rem; bottom: 0; display: flex; align-items: center;"><span>￦</span></div>
              </div>
            </m-form>

            <m-form label="안전등급" :value="form.body.baseInfo.안전등급" >
              <vs-input class="w-full" v-model="form.body.baseInfo.안전등급"/>
            </m-form>
            <m-form label="시설물 위치" :value="form.body.baseInfo.시설물위치" >
              <vs-input class="w-full" v-model="form.body.baseInfo.시설물위치"/>
            </m-form>
            <m-form label="시설물 규모" :value="`연면적 : ${form.body.baseInfo.연면적}㎡`">
              <m-form label="연면적" margin="m-0" :value="form.body.baseInfo.연면적" >
                <div style="position: relative">
                  <div class="text-padding-right">
                    <vs-input class="w-full" v-model="form.body.baseInfo.연면적"/>
                  </div>
                  <div style="position: absolute; top: 0; right: 0.5rem; bottom: 0; display: flex; align-items: center;"><span>㎡</span></div>
                </div>
              </m-form>
            </m-form>

            <m-form ></m-form>
            <m-form ></m-form>
            <m-form label=" " :value="`층수 : ${form.body.baseInfo.층수}`">
              <m-form label="층수" margin="m-0"  :value="form.body.baseInfo.층수" >
                <div style="position: relative">
                  <vs-input class="w-full" v-model="form.body.baseInfo.층수"/>
                </div>
              </m-form>
            </m-form>
          </m-group>

          <!-- 책임(참여)기술자 현황 -->
          <m-title style="margin-top: 2rem; " label="책임(참여)기술자 현황" />
          <m-form label="중대결함" flex-align="start" label-margin="mt-4" :value="form.body.기술자현황.중대결함">
            <vs-textarea class="w-full" style="resize: none;" :rows="5" v-model="form.body.기술자현황.중대결함"/>
          </m-form>
          <m-form label="점검 주요결과" flex-align="start" label-margin="mt-4" :value="form.body.기술자현황.점검주요결과">
            <vs-textarea class="w-full" style="resize: none;" :rows="5" v-model="form.body.기술자현황.점검주요결과"/>
          </m-form>
          <m-form label="주요 보수·보강" flex-align="start" label-margin="mt-4" :value="form.body.기술자현황.주요수보강">
            <vs-textarea class="w-full" style="resize: none;" :rows="5"  v-model="form.body.기술자현황.주요수보강"/>
          </m-form>


          <m-title style="margin-top: 2rem; " label="점검 실시결과 현황">
            <template slot="right">
              <vs-button class="w-full mr-4" color="secondary" style="white-space: nowrap;" type="border" @click="handleCheckAddResult">+ 항목추가</vs-button>
              <vs-button class="w-full" color="secondary" style="white-space: nowrap;" type="border" @click="handleCheckDelResult">- 항목삭제</vs-button>
            </template>
          </m-title>
          <vs-row class="mb-8">
            <vs-col class="border">
              <ul class="table">
                <li class="thead border-top"
                    style="grid-template-columns: 50px 1fr 1fr 3fr 1fr;"
                    :style="isPrint ? { gridTemplateColumns: '1fr 1fr 3fr 1fr' } : { gridTemplateColumns: '50px 1fr 1fr 3fr 1fr' }"
                >
                  <p v-if="!isPrint" class="p-2" >
                    <vs-checkbox :readonly="board.readonly" :value="점검실시결과현황_checkAll" @change="onClickCheckResultCheckAll"></vs-checkbox>
                  </p>
                  <p class="p-4">구분</p>
                  <p class="p-4">성명</p>
                  <p class="p-4">과업 참여기간</p>
                  <p class="p-4">기술등급</p>
                </li>
                <li v-for="(item, index) in form.body.점검실시결과현황" :key="`점검실시결과현황_${index}`"
                    class="tbody"
                    style="grid-template-columns: 50px 1fr 1fr 3fr 1fr;"
                    :style="isPrint ? { gridTemplateColumns: '1fr 1fr 3fr 1fr' } : { gridTemplateColumns: '50px 1fr 1fr 3fr 1fr' }"
                >
                  <p v-if="!isPrint" class="p-2" >
                    <vs-checkbox :readonly="board.readonly" v-model="item.is_checked"></vs-checkbox>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.구분 }}</span>
                    <vs-select v-else class="w-full"  autocomplete v-model="item.구분">
                      <vs-select-item value="책임기술자" text="책임기술자" />
                      <vs-select-item value="참여기술자" text="참여기술자" />
                    </vs-select>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.성명 }}</span>
                    <vs-input v-else class="w-full" v-model="item.성명"/>
                  </p>
                  <p v-if="isPrint" class="p-2" >
                    {{item.참여시작일}} ~ {{item.참여종료일}}
                  </p>
                  <p v-else class="p-2" style="display: grid; grid-template-columns: 1fr 50px 1fr; align-items: center;">
                    <date-selector v-model="item.참여시작일"/>
                    <span>~</span>
                    <date-selector v-model="item.참여종료일"/>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.기술등급 }}</span>
                    <vs-select v-else class="w-full"  autocomplete v-model="item.기술등급">
                      <vs-select-item value="특급기술자" text="특급기술자" />
                      <vs-select-item value="고급기술자" text="고급기술자" />
                      <vs-select-item value="중급기술자" text="중급기술자" />
                      <vs-select-item value="초급기술자" text="초급기술자" />
                    </vs-select>
                  </p>
                </li>
              </ul>
            </vs-col>
          </vs-row>

          <!-- 참고사항 -->
          <m-title style="margin-top: 2rem; " label="가스 압력 기록 결과" >
            <template slot="right">
              <feather-icon icon="AlertCircleIcon" style="width:18px; margin-right: 4px; "/>
              <span style="font-size: 14px;">1MB 이하의 이미지형식(JPG, PNG 등) 파일만 업로드 가능합니다</span>
            </template>
          </m-title>
          <div class="border-x border-top">
            <vs-row>
              <vs-col class="w-1/2 grid border-right" style="grid-template-rows: 324px auto;">
                <div class="w-full h-full p-4">
                  <file-uploader type="only-image" class="w-full h-full" v-model="form.body.가스압력기록결과[0].image" />
                </div>
                <div class="w-full px-4 py-2 border-y" style="background-color: #F9F9F9">
                  <vs-input class="w-full" placeholder="내용입력" v-model="form.body.가스압력기록결과[0].value"/>
                </div>
              </vs-col>
              <vs-col class="w-1/2 grid" style="grid-template-rows: 324px auto;">
                <div class="w-full h-full p-4">
                  <file-uploader type="only-image" class="w-full h-full" v-model="form.body.가스압력기록결과[1].image" />
                </div>
                <div class="w-full px-4 py-2 border-y" style="background-color: #F9F9F9">
                  <vs-input class="w-full" placeholder="내용입력" v-model="form.body.가스압력기록결과[1].value"/>
                </div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col class="w-1/2 grid border-right" style="grid-template-rows: 324px auto;">
                <div class="w-full h-full p-4">
                  <file-uploader type="only-image" class="w-full h-full" v-model="form.body.가스압력기록결과[2].image" />
                </div>
                <div class="w-full px-4 py-2 border-y" style="background-color: #F9F9F9">
                  <vs-input class="w-full" placeholder="내용입력" v-model="form.body.가스압력기록결과[2].value"/>
                </div>
              </vs-col>
              <vs-col class="w-1/2 grid" style="grid-template-rows: 324px auto;">
                <div class="w-full h-full p-4">
                  <file-uploader type="only-image" class="w-full h-full" v-model="form.body.가스압력기록결과[3].image" />
                </div>
                <div class="w-full px-4 py-2 border-y" style="background-color: #F9F9F9">
                  <vs-input class="w-full" placeholder="내용입력" v-model="form.body.가스압력기록결과[3].value"/>
                </div>
              </vs-col>
            </vs-row>
          </div>

          <!-- 정기안전점검 실시결과 요약표 -->
          <m-title style="margin-top: 2rem; " label="정기안전점검 실시결과 요약표" >
            <template slot="right">
              <vs-button class="w-full mr-4" color="secondary" style="white-space: nowrap;" type="border" @click="handleCheckAddCheckResult">+ 항목추가</vs-button>
              <vs-button class="w-full" color="secondary" style="white-space: nowrap;" type="border" @click="handleCheckDelCheckResult">- 항목삭제</vs-button>
            </template>
          </m-title>
          <vs-row class="mb-8">
            <vs-col class="border">
              <ul class="table">
                <li class="thead border-top"
                    style="grid-template-columns: 50px 1fr 1fr 1fr;"
                    :style="isPrint ? { gridTemplateColumns: '1fr 1fr 1fr'} : { gridTemplateColumns: '50px 1fr 1fr 1fr'}"
                >
                  <p class="p-2" v-if="!isPrint">
                    <vs-checkbox :readonly="board.readonly" :value="정기안전점검실시결과요약표_checkAll" @change="onClickCheckResult2CheckAll"></vs-checkbox>
                  </p>
                  <p class="p-4">부재(부위)</p>
                  <p class="p-4">점검결과</p>
                  <p class="p-4">조치 필요사항</p>
                </li>
                <li v-for="(item, index) in form.body.정기안전점검실시결과요약표" :key="`정기안전점검실시결과요약표_${index}`"
                    class="tbody "
                    style="grid-template-columns: 50px 1fr 1fr 1fr;"
                    :style="isPrint ? { gridTemplateColumns: '1fr 1fr 1fr'} : { gridTemplateColumns: '50px 1fr 1fr 1fr'}"
                >
                  <p class="p-2" v-if="!isPrint">
                    <vs-checkbox :readonly="board.readonly" v-model="item.is_checked"></vs-checkbox>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.부재 }}</span>
                    <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="5" v-model="item.부재"/>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.점검결과 }}</span>
                    <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="5" v-model="item.점검결과"/>
                  </p>
                  <p class="p-2">
                    <span v-if="isPrint">{{ item.조치필요사항 }}</span>
                    <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="5" v-model="item.조치필요사항"/>
                  </p>
                </li>
              </ul>
            </vs-col>
          </vs-row>

          <!-- 점검항목 -->
          <m-title style="margin-top: 2rem;" label="점검항목" />
          <m-check-table
            title="구분"
            :menus="menuA"
            menu-width="151px"
          >
            <template v-slot:header>
              <check-table-header :division="1" title="해당설비"/>
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(1, 1fr)">
                <check-table-body-item
                  v-for="work in form.body.check.checkListA[menu]"
                  :key="work.text"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                />
              </div>
            </template>
          </m-check-table>

          <!-- 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검결과" />
          <div class="grid border-y" style="grid-template-columns: 151px 1fr;">
            <vs-col style="display: flex; justify-content: center; align-items: center; background-color: #f9f9f9">평가결과</vs-col>
            <vs-col class="border-left p-4">
              <div style="display: flex; align-items: center; min-height: 40px;">
                <div style="width:180px; display: flex; align-items: center; ">
                  <i class="small-dot"/>
                  <span>안전등급(종합상태 점수)</span>
                </div>
                <span v-if="isPrint">{{totalPoint}}</span>
                <vs-input v-else style="width: 80px;" :readonly="true" :value="totalPoint"/>
              </div>
              <div style="display: flex; align-items: center; min-height: 40px;">
                <div style="width:180px; display: flex; align-items: center; ">
                  <i class="small-dot"/>
                  <span>긴급점검·진단 필요성</span>
                </div>

                <div style="display: flex; align-items: center;">
                  <span v-if="isPrint && form.body.점검결과.긴급점검진단필요성.있음">있음</span>
                  <vs-checkbox v-if="!isPrint" v-model="form.body.점검결과.긴급점검진단필요성.있음" @change="()=>{
                    form.body.점검결과.긴급점검진단필요성.없음 = false
                  }">있음</vs-checkbox>
                  <span v-if="isPrint && form.body.점검결과.긴급점검진단필요성.없음">없음</span>
                  <vs-checkbox v-if="!isPrint" v-model="form.body.점검결과.긴급점검진단필요성.없음" @change="()=>{
                    form.body.점검결과.긴급점검진단필요성.있음 = false
                  }">없음</vs-checkbox>
                </div>
              </div>
              <div  style="display: flex; align-items: center; min-height: 40px;">
                <div style="width:180px; display: flex; align-items: center; ">
                  <i class="small-dot"/>
                  <span>안전조치 필요성</span>
                </div>
                <div style="display: flex; align-items: center;">
                  <span v-if="isPrint && form.body.점검결과.안전조치필요성.있음">있음</span>
                  <vs-checkbox v-if="!isPrint" v-model="form.body.점검결과.안전조치필요성.있음" @change="()=>{
                    form.body.점검결과.안전조치필요성.없음 = false
                  }">있음</vs-checkbox>
                  <span v-if="isPrint && form.body.점검결과.안전조치필요성.있음">없음</span>
                  <vs-checkbox v-if="!isPrint" v-model="form.body.점검결과.안전조치필요성.없음" @change="()=>{
                    form.body.점검결과.안전조치필요성.있음 = false
                  }">없음</vs-checkbox>
                </div>
              </div>
            </vs-col>
          </div>
          <div class="grid border-bottom" style="grid-template-columns: 151px 1fr;">
            <vs-col style="display: flex; justify-content: center; align-items: center; background-color: #f9f9f9">종합의견 및 특기사항</vs-col>
            <vs-col class="border-left p-4">
              <span v-if="isPrint">{{form.body.점검결과.종합의견}}</span>
              <vs-textarea v-else class="m-0" :rows="5" v-model="form.body.점검결과.종합의견"/>
            </vs-col>
          </div>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'
import FileUploader from '@/views/components/FileUploader'
import TimeSelector from '@/views/components/TimeSelector'
import CheckTableBodyItem from '@/views/write/safetycheck/periodic_safety_check_building/component/CheckTableBodyItem'
import CheckTableHeader from '@/views/write/safetycheck/periodic_safety_check_building/component/CheckTableHeader'

export default {
  name: 'PeriodicSafetyCheckBuilding',
  components: {
    TimeSelector,
    FileUploader,
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },
      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: '',
            com_name: '',
            workTypeTitleList: ['주요시설', '일반시설', '부대시설'],
            workType: [true, true, true],
            check_stime: '',
            check_etime: '',
            용역명: '',
            관리주체: '',
            소유자: '',
            공동수급: '',
            계약방법: '',
            시설물구분: '',
            구분: '',
            종별: '',
            사용승인일: '',
            금액: '',
            안전등급: '',
            시설물위치: '',
            연면적: '',
            층수: '',
          },
          기술자현황: {
            중대결함: '',
            점검주요결과: '',
            주요수보강: '',
          },
          점검실시결과현황: [],
          가스압력기록결과: [
            { image: {}, value: ''},
            { image: {}, value: ''},
            { image: {}, value: ''},
            { image: {}, value: ''},
          ],
          정기안전점검실시결과요약표: [],
          check: {
            checkListA: {
              '주요시설' : [
                { text: '시설물 주변의 지반 침하 또는 이로 인한 건물의 기울음 균열상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '구조부재의 균열, 누수상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '구조부재의 변형(처짐, 기울음, 단면손실 등)상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '구조부재의 철근 부식, 노출 또는 콘크리트 박리·박락 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '철골부재의 접합부 상태(볼트풀림, 누락, 탈락, 용접불량)', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '철골부재의 변형(기울음, 좌굴 등) 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '철골부재의 부식 또는 부재 미시공, 단면손실 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
              ],
              '일반시설' : [
                { text: '옥상, 지붕 방수층의 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '외부 마감재(외단열, 치장벽돌, 미장 등) 및 처마의 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '내부 마감재 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '내부 칸막이벽(벽돌, 블록 등)의 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '용도변경 또는 사용상 물품 적치 등으로 인한 과하중 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
              ],
              '부대시설' : [
                { text: '옹벽, 석축, 담장의 배수 및 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '비탈면(사면, 절개지)의 배수 및 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '외부 난간 및 파라펫 설치 및 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '내부 난간 설치 및 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '환기구의 손상 상태(덮개 설치 유무 포함)', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
                { text: '점검로 등 손상 상태', isAction: false, data: { '보수필요': false, '점검자의견': '', 'result': {'우수': false, '양호': false, '보통': false, '미흡': false, '해당없음': false} } },
              ],
            },
            now: '',
            next: ''
          },
          점검결과: {
            긴급점검진단필요성: { 있음: true, 없음: false},
            안전조치필요성: { 있음: true, 없음: false},
            종합의견: '',
          }

        }
      },

      fileList: [],
      test: false,
    }
  },
  computed:{
    totalPoint () {
      let point = 0;

      const checkList = this.form.body.check.checkListA
      const 주요시설 = checkList['주요시설']
      const 일반시설 = checkList['일반시설']
      const 부대시설 = checkList['부대시설']

      let sum1 = 0;
      let sum2 = 0;
      let sum3 = 0;

      for (const item of 주요시설) {
        if (item.data.result['우수']) {
          sum1 += 10
        } else if (item.data.result['양호']) {
          sum1 += 8
        } else if (item.data.result['보통']) {
          sum1 += 5
        } else if (item.data.result['미흡']) {
          sum1 += 2
        } else {
          sum1 += 0;
        }
      }

      for (const item of 일반시설) {
        if (item.data.result['우수']) {
          sum2 += 10
        } else if (item.data.result['양호']) {
          sum2 += 8
        } else if (item.data.result['보통']) {
          sum2 += 5
        } else if (item.data.result['미흡']) {
          sum2 += 2
        } else {
          sum2 += 0;
        }
      }

      for (const item of 부대시설) {
        if (item.data.result['우수']) {
          sum3 += 10
        } else if (item.data.result['양호']) {
          sum3 += 8
        } else if (item.data.result['보통']) {
          sum3 += 5
        } else if (item.data.result['미흡']) {
          sum3 += 2
        } else {
          sum3 += 0;
        }
      }

      point += sum1 / 주요시설.length * 0.6
      point += sum2 / 일반시설.length * 0.2
      point += sum3 / 부대시설.length * 0.2

      point = Math.floor(point * 100) / 100

      if (point >= 9) {
        return `A (${point})`
      } else if (point >= 7) {
        return `B (${point})`
      } else if (point >= 5) {
        return `C (${point})`
      } else if (point >= 2) {
        return `D (${point})`
      } else {
        return `E (${point})`
      }
    },
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.baseInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          menus.push(this.form.body.baseInfo.workTypeTitleList[i])
        }
      }
      return menus
    },
    menuResults () {
      return ['우수', '양호', '보통', '미흡', '해당없음']
    },
    점검실시결과현황_checkAll () {
      let all = true
      if (this.form.body.점검실시결과현황.length === 0) return false;

      for (const item of this.form.body.점검실시결과현황) {
        if (!item.is_checked) {
          all = false;
          break;
        }
      }
      return all;
    },
    정기안전점검실시결과요약표_checkAll () {
      let all = true
      if (this.form.body.정기안전점검실시결과요약표.length === 0) return false;

      for (const item of this.form.body.정기안전점검실시결과요약표) {
        if (!item.is_checked) {
          all = false;
          break;
        }
      }
      return all;
    },
    comName () {
      if (this.isUpdateMode) {
      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {
    onClickCheckResultCheckAll () {
      let isChecked = !this.점검실시결과현황_checkAll;
      for (const item of this.form.body.점검실시결과현황) {
        item.is_checked = isChecked;
      }
    },
    onClickCheckResult2CheckAll () {
      let isChecked = !this.정기안전점검실시결과요약표_checkAll;
      for (const item of this.form.body.정기안전점검실시결과요약표) {
        item.is_checked = isChecked;
      }
    },
    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      const projectId = parseInt(this.$route.params.proj_id)

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {
      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    },

    handleCheckAddResult () {
      this.form.body.점검실시결과현황.push({
        is_checked: false,
        구분: '',
        성명: '',
        참여시작일: '',
        참여종료일: '',
        기술등급: '',
      })
    },
    handleCheckDelResult () {
      let i=0;
      for (i=0 ; i<this.form.body.점검실시결과현황.length; i++) {
        const item = this.form.body.점검실시결과현황[i]
        if (item.is_checked) {
          this.form.body.점검실시결과현황.remove(item)
          i--;
        }
      }
    },
    handleCheckAddCheckResult () {
      this.form.body.정기안전점검실시결과요약표.push({
        is_checked: false,
        부재: '',
        점검결과: '',
        조치필요사항: '',
      })
    },
    handleCheckDelCheckResult () {
      let i=0;
      for (i=0 ; i<this.form.body.정기안전점검실시결과요약표.length; i++) {
        const item = this.form.body.정기안전점검실시결과요약표[i]
        if (item.is_checked) {
          this.form.body.정기안전점검실시결과요약표.remove(item)
          i--;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex; justify-content: center; align-items: center;
  min-height: 50px;
  background-color: #f9f9f9;
}
.text-padding-right {

  .vs-input--input.normal {
    padding-right: 2rem !important;
  }
}
.small-dot {
  min-width: 4px;
  min-height: 4px;
  width: 4px;
  height: 4px;
  background-color: #3C3C3C;
  border-radius: 2px;
  margin-right: 8px;
}
</style>

<style lang="scss">
.text-padding-right {
  .vs-input--input.normal{
    padding-right: 2rem !important;
  }
}
</style>
